import { Grid2, Paper } from '@mui/material';
import { GridRowParams } from '@mui/x-data-grid';

import { useNavigate } from 'react-router';

import { useGetInvoicesListQuery } from 'api/hooks/billing/invoices';
import { DataGrid } from 'app/components';
import { useCurrentURL } from 'utils/hooks/useCurrentURL';
import { useTableQuery } from 'utils/hooks/useTableQuery';

import { useFinanceInvoiceColumns } from '../../components/columns';

interface Props {
  search: string;
}
export const FinalInvoiceTab = ({ search }: Props) => {
  const currentURL = useCurrentURL();
  const navigate = useNavigate();

  const { page, pageSize, sortingModel, handlePaginationChange, handleSortModelChange } =
    useTableQuery({
      defaultSort: [{ field: 'invoiceDate', sort: 'desc' }],
      defaultPageSize: 100,
      sortKey: 'sort_final',
      paginationKeys: { page: 'page_final', pageSize: 'pageSize_final' }
    });

  const { data: invoicesData, isFetching } = useGetInvoicesListQuery({
    params: {
      state: 'FINAL',
      skip: page * pageSize,
      take: pageSize,
      sort: sortingModel[0]?.field,
      sortOrder: sortingModel[0]?.sort,
      search: search
    }
  });

  const handleRowClick = (params: GridRowParams) => {
    navigate(`/billing/invoices/${params.id}`, {
      state: { back: currentURL }
    });
  };

  return (
    <Grid2 component={Paper} style={{ height: '75vh' }} container size={12}>
      <DataGrid
        style={{ height: '100%', width: '100%' }}
        loading={isFetching}
        columns={useFinanceInvoiceColumns({ disableStateSorting: true })}
        columnVisibilityModel={{ pdfPreview: false }}
        rows={invoicesData?.data}
        onRowClick={handleRowClick}
        rowCount={invoicesData?.count || 0}
        paginationMode="server"
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={handlePaginationChange}
        sortingMode="server"
        sortModel={sortingModel}
        onSortModelChange={handleSortModelChange}
        disableColumnMenu
      />
    </Grid2>
  );
};
